const popoverMenu = document.getElementById('mainNav'); // Replace with your popover's ID
const desktopBreakpoint = window.matchMedia('(min-width: 1023.2px)'); // Replace with your desktop width

function handleResponsivePopover(e) {
  // If the screen is now desktop size AND the popover happens to be open
  if (e.matches && popoverMenu.matches(':popover-open')) {
    popoverMenu.hidePopover();
  }
}

// 1. Run the check immediately on page load
handleResponsivePopover(desktopBreakpoint);

// 2. Listen for the browser resizing past that breakpoint
desktopBreakpoint.addEventListener('change', handleResponsivePopover);